import { SelectedCategoryStateInterface } from "../interfaces/interface";
import { DishCard } from "../hooks/useMenuItemsEditPage";

export const getMenuStep = (category: SelectedCategoryStateInterface, dishes: DishCard[]): number => {
    if (dishes.length > 0) {
        return 2;
    }
    return category.categoryId ? 1 : 0;
};
